<div class="grid">
  <div class="sm:col-8 col-12">
    <p-calendar [(ngModel)]="date" [inline]="true" (onSelect)="updateSelectedOptionBasedOnSelectedDate()"></p-calendar>
  </div>
  <div class="sm:col-4 col-8 mx-auto flex align-items-center">
    <p-listbox
      [options]="invoiceOptions"
      [(ngModel)]="selectedInvoiceOption"
      optionLabel="name"
      optionValue="code"
      (onChange)="selectedOption($event)"
      class="listboxDate"
    ></p-listbox>
  </div>
</div>

<div class="p-datepicker-buttonbar">
  <button pButton type="button" label="Clear" class="p-button-outlined" (click)="resetDate()"></button>
  <button pButton type="button" label="Save" class="p-button-outlined" icon="pi pi-check" (click)="setDueDate()"></button>
</div>
